export default {
  context: ['currentUser'],
  configuration: ['currentSite'],
  inject: ['order'],
  props: {
    orderItem: {
      type: Object,
      required: false
    },
    itemOrderItem: {
      type: Object,
      required: false
    }
  },
  computed: {
    inventoryStrategy () {
      return this.currentSite.activeInventoryStrategy
    },
    selectedItemVariationId () {
      return this.itemOrderItem?.itemVariation?.id
    },
    selectedModifierIds () {
      return _.map(this.itemOrderItem?.itemModifiers?.data, 'modifier.id')
    },
    screen () {
      return this.order.nearestShowing?.screen
    }
  },
  emits: ['request-authorization'],
  methods: {
    deliveryType ({
      button,
      item,
      itemVariation,
      /**
       * Item should always be passed with modifier.
       */
      modifier: _modifier
    }) {
      const deliveryTypeFromOrderItem = this.orderItem?.deliveryTypeName
      const deliveryTypeFromOrder = this.order.deliveryTypeName
      const resolvedItem = button?.resolvedItem || itemVariation?.item || item
      return deliveryTypeFromOrderItem || deliveryTypeFromOrder || resolvedItem?.defaultDeliveryType?.(this.order) || null
    },
    availableStock ({
      button,
      item,
      itemVariation,
      modifier
    }) {
      return this.$availableStock({
        button,
        deliveryType: this.deliveryType({
          button,
          item,
          itemVariation,
          modifier
        }),
        item,
        itemVariation,
        modifier,
        screen: this.screen,
        selectedModifierIds: this.selectedModifierIds,
        selectedItemVariationId: this.selectedItemVariationId
      })
    },
    isOutOfStock ({
      button,
      item,
      itemVariation,
      modifier
    }) {
      return this.$isOutOfStock({
        button,
        deliveryType: this.deliveryType({
          button,
          item,
          itemVariation,
          modifier
        }),
        item,
        itemVariation,
        modifier,
        screen: this.screen,
        selectedModifierIds: this.selectedModifierIds,
        selectedItemVariationId: this.selectedItemVariationId
      })
    },
    reduceOpacity ({
      button,
      item,
      itemVariation,
      modifier
    }) {
      return this.$reduceOpacity({
        button,
        deliveryType: this.deliveryType({
          button,
          item,
          itemVariation,
          modifier
        }),
        inventoryStrategy: this.inventoryStrategy,
        item,
        itemVariation,
        modifier,
        screen: this.screen,
        selectedModifierIds: this.selectedModifierIds,
        selectedItemVariationId: this.selectedItemVariationId
      })
    },
    showAvailabilityBadge ({
      button,
      item,
      itemVariation,
      modifier
    }) {
      return this.$showAvailabilityBadge({
        button,
        deliveryType: this.deliveryType({
          button,
          item,
          itemVariation,
          modifier
        }),
        inventoryStrategy: this.inventoryStrategy,
        item,
        itemVariation,
        modifier,
        screen: this.screen,
        selectedModifierIds: this.selectedModifierIds,
        selectedItemVariationId: this.selectedItemVariationId
      })
    },
    availabilityBadgeColor ({
      button,
      item,
      itemVariation,
      modifier
    }) {
      return this.$availabilityBadgeColor({
        button,
        deliveryType: this.deliveryType({
          button,
          item,
          itemVariation,
          modifier
        }),
        inventoryStrategy: this.inventoryStrategy,
        item,
        itemVariation,
        modifier,
        screen: this.screen,
        selectedModifierIds: this.selectedModifierIds,
        selectedItemVariationId: this.selectedItemVariationId
      })
    },
    checkForSalesRestrictions ({
      button,
      item,
      itemVariation,
      modifier,
      successCallback
    }) {
      return this.$checkForSalesRestrictions({
        button,
        currentUser: this.currentUser,
        deliveryType: this.deliveryType({
          button,
          item,
          itemVariation,
          modifier
        }),
        inventoryStrategy: this.inventoryStrategy,
        item,
        itemVariation,
        modifier,
        screen: this.screen,
        selectedModifierIds: this.selectedModifierIds,
        selectedItemVariationId: this.selectedItemVariationId,
        successCallback
      })
    }
  }
}
